module.exports = __webpack_public_path__ + "static/media/uniswap.c4b3195d.svg";